import map from 'lodash/map';

import ApiToken from 'src/models/Integrations/apiToken';
import apiTokensResource from 'src/actions/integrations/apiTokensResource';
import find from 'lodash/find';
import generateId from 'src/lib/generateId';
import organizationResource from 'src/actions/organization/organizationResource';
import useDocumentResource from 'src/presentation/hooks/useDocumentResource';
import useResource from 'src/presentation/hooks/useResource';
import { RootState } from 'src/actions/configuration/rootReducer';
import { toDateTimeString } from 'src/presentation/components/pages/shared/utils/TimeUtils';
import { useDispatch, useSelector } from 'react-redux';

const tokenNamePrefix = 'Token';

const useApiTokens = () => {
  const dispatch = useDispatch();
  const {
    values: apiTokens,
    errors: apiTokensErrors,
    loadingState: apiTokensLoadingState,
  } = useResource(apiTokensResource);

  const orgId = useSelector((state: RootState) => state.auth.orgId);
  const { value: organization } = useDocumentResource(organizationResource, {
    fetch: true,
    params: { orgId },
  });

  const apiTokensWithDates = map(apiTokens, (v: ApiToken) => {
    const createdAtString = toDateTimeString(v.createdAt);
    const lastUsedAtString = toDateTimeString(v.lastUsedAt) || '';
    return { ...v, createdAtString, lastUsedAtString };
  });

  const addToken = () => {
    const { add } = apiTokensResource.effects;
    let tokenName = '';

    for (let index = 1; ; index++) {
      tokenName = `${tokenNamePrefix} ${index}`;
      if (!find(apiTokens, token => token.name === tokenName)) {
        break;
      }
    }
    const token = {
      id: generateId(),
      name: tokenName,
      createdAt: new Date().toISOString(),
    };

    dispatch(add({}, token));
  };

  return { addToken, apiTokens: apiTokensWithDates, apiTokensErrors, apiTokensLoadingState, organization };
};

export default useApiTokens;
